import { Route, Switch } from 'react-router-dom';

import EvaluationFormCreator from './EvaluationFormCreator';
import EvaluationFormEditorID from './EvaluationFormEditor';
import EvaluationFormsListContainer from './EvaluationFormsListContainer';

export default function ConversationsSettings() {
	return (
		<Switch>
			<Route path="/settings/conversations/new">
				<EvaluationFormCreator />
			</Route>
			<Route path="/settings/conversations/:id">
				{({ match }) => <EvaluationFormEditorID id={match!.params.id!} />}
			</Route>
			<Route>
				<EvaluationFormsListContainer />
			</Route>
		</Switch>
	);
}
